import { MetadataValue } from 'generated/graphql';
import {
  MetadataValue as MetadataTypeValue,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

interface GenerateWhereClauseFromMetadataKeyValue {
  metadataFieldKey: string;
  metadataValue: MetadataValue;
}

export const generateWhereClauseFromMetadataKeyValue = ({
  metadataFieldKey,
  metadataValue,
}: GenerateWhereClauseFromMetadataKeyValue) => {
  const metadataWhereClause: WhereClause = {
    filter: {
      metadataFilter: {
        key: metadataFieldKey,
        ...getTypeSpecificMetadataValues(metadataValue),
      },
    },
  };
  return metadataWhereClause;
};

const getTypeSpecificMetadataValues = (
  metadataValue: MetadataValue,
): MetadataTypeValue => {
  if (metadataValue.b) {
    return {
      type: 'boolean',
      values: metadataValue.b,
    };
  }

  if (metadataValue.n) {
    return {
      type: 'number',
      values: metadataValue.n,
    };
  }

  return {
    type: 'string',
    values: metadataValue.s ?? [],
  };
};
